<template>
  <v-row dense>
    <v-col class="py-0">
      <v-card class="pa-2 my-2 mr-2">
        <v-row no-gutters>
          <v-col class="d-flex align-center">
            <span class="subtitle-1">Згідно грейдів:</span>
            <v-spacer />
            <span
              class="title"
            >{{ totalPayedHours
            }}<span class="font-weight-medium body-1"> год</span></span>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
    <v-col class="py-0">
      <v-card class="pa-2 my-2 mr-2">
        <v-row no-gutters>
          <v-col class="d-flex align-center">
            <span class="subtitle-1">Фактично:</span>
            <v-spacer />
            <span
              class="title"
            >{{ totalTimeSpentHours
            }}<span class="font-weight-medium body-1"> год</span></span>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
    <v-col class="py-0">
      <v-card class="pa-2 my-2 mr-2">
        <v-menu
          :disabled="employeesCount === 0"
          open-on-hover
          offset-y
          :nudge-bottom="8"
          :nudge-left="10"
        >
          <template
            v-slot:activator="{
              on,
            }"
          >
            <v-row
              no-gutters
              v-on="on"
            >
              <v-col class="d-flex align-center">
                <v-card-text class="subtitle-1 pa-0">
                  Виконавців:
                </v-card-text>
                <v-spacer />
                <v-card-text class="title text-right pa-0">
                  {{ employeesCount }}
                </v-card-text>
              </v-col>
            </v-row>
          </template>
          <v-card>
            <v-list>
              <v-list-item
                v-for="(employee, index) in employees"
                :key="index"
              >
                <v-list-item-content>
                  {{ employee.title }}
                </v-list-item-content>
                <v-list-item-action>
                  {{ (employee.payedSeconds / 3600).toFixed(2) }} ({{
                    (employee.spentSeconds / 3600).toFixed(2)
                  }})
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>
      </v-card>
    </v-col>
    <v-col class="py-0">
      <v-card class="pa-2 my-2">
        <v-row no-gutters>
          <v-col>
            <v-menu
              :disabled="employeesCount === 0"
              :nudge-bottom="40"
              :nudge-left="200"
              open-on-hover
              offset-x
            >
              <template v-slot:activator="{ on }">
                <v-row
                  no-gutters
                  v-on="on"
                >
                  <v-col class="d-flex align-center">
                    <v-card-text class="subtitle-1 pa-0">
                      Середній грейд:
                    </v-card-text>
                    <v-card-text
                      class="title text-right pa-0"
                      style="width: 40%"
                    >
                      {{ averageGrade.toFixed(2) }}
                    </v-card-text>
                  </v-col>
                </v-row>
              </template>
              <v-card>
                <v-list>
                  <v-list-item
                    v-for="(employee, index) in employees"
                    :key="index"
                  >
                    <v-list-item-content>
                      {{ employee.title }}
                    </v-list-item-content>
                    <v-list-item-action>
                      {{ employee.grade }}
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-menu>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
    <v-col class="py-0">
      <v-card class="pa-2 my-2">
        <v-row no-gutters>
          <v-col>
            <v-menu
              :disabled="issuesCount === 0"
              :nudge-bottom="40"
              :nudge-left="200"
              open-on-hover
              offset-x
            >
              <template v-slot:activator="{ on }">
                <v-row
                  no-gutters
                  v-on="on"
                >
                  <v-col class="d-flex align-center">
                    <v-card-text class="subtitle-1 pa-0">
                      Задач:
                    </v-card-text>
                    <v-spacer />
                    <v-card-text class="title text-right pa-0">
                      {{ issuesCount }}
                    </v-card-text>
                  </v-col>
                </v-row>
              </template>
              <v-card>
                <v-list>
                  <v-list-item
                    v-for="(issueStatus, index) in issuesByStatuses"
                    :key="index"
                  >
                    <v-list-item-content>
                      {{ issueStatus.status }}
                    </v-list-item-content>
                    <v-list-item-action>
                      {{ issueStatus.count }}
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-menu>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import _ from "lodash";

export default {
  props: ["source"],
  computed: {
    issuesByStatuses() {
      const issuesByStatuses = [];
      const groupedByStatuses = _.groupBy(this.source, (i) => i.status);
      for (const key in groupedByStatuses) {
        issuesByStatuses.push({
          status: key,
          count: groupedByStatuses[key].length,
        });
      }
      return issuesByStatuses;
    },

    totalTimeSpentHours() {
      const totalTimeSpentSeconds = this.source.reduce((total, i) => {
        const issueTotal = i.worklog.reduce((sum, w) => {
          return sum + w.timeSpentSeconds;
        }, 0);
        return total + issueTotal;
      }, 0);

      const totalTimeSpentHours = (totalTimeSpentSeconds / 3600).toFixed(2);

      this.$emit("spentChange", totalTimeSpentHours);
      return totalTimeSpentHours;
    },

    totalPayedHours() {
      const totalPayedHours = this.source.reduce((total, i) => {
        const issueTotal = i.worklog.reduce((total, w) => {
          return total + w.payedHours;
        }, 0);
        return total + issueTotal;
      }, 0);
      this.$emit("payedChange", totalPayedHours.toFixed(2));

      return totalPayedHours.toFixed(2);
    },

    issuesCount() {
      return this.source.length;
    },

    employees() {
      const worklogs = [];
      this.source.forEach((i) => {
        i.worklog.forEach((w) => {
          worklogs.push({
            title: w.employee,
            payedSeconds: w.payedSeconds,
            spentSeconds: w.timeSpentSeconds,
            issueKey: i.key,
          });
        });
      });


      const groupedByIssues = Object.entries(_.groupBy(worklogs, (e) => e.issueKey));

      const employees = [];
      groupedByIssues.forEach(([, worklogs]) => {
        worklogs.forEach(e => {
          employees.find(function(v, i, obj) {
            if (v.title === e.title) {
              obj[i].payedSeconds += e.payedSeconds;
              obj[i].spentSeconds += e.spentSeconds;
              if (obj[i].issueKey !== e.issueKey) {
                obj[i].issuesCount++;
                obj[i].issueKey = e.issueKey;
              }
              return true;
            }
            return false;
          }) == undefined ? employees.push(
              { title: e.title, payedSeconds: e.payedSeconds, spentSeconds: e.spentSeconds, issueKey: e.issueKey, issuesCount: 1 }) : false;
        });
      });

      return employees.map(e => {
        return {
          title: e.title,
          payedSeconds: e.payedSeconds,
          spentSeconds: e.spentSeconds,
          grade: e.payedSeconds / e.spentSeconds,
        };
      });
    },
    employeesCount() {
      return this.employees.length;
    },
    totalGrade() {
      const employeesGrade = this.employees.map(e => e.grade);
      return employeesGrade.reduce((previousValue, currentValue) => previousValue + currentValue, 0);
    },
    averageGrade() {
      return this.employeesCount ? this.totalGrade / this.employeesCount : 0;
    },
  },
};
</script>

<style scoped>
.v-menu {
  width: 100%;
}
</style>
